import { CreditCard } from '../models/credit-card';

export const emptyCreditCard: CreditCard = {
    id: null,
    name: 'New Card',
    number: '',
    active: false,
    successDate: null,
    masked: '',
    paymentProvisionId: null,
    issuer: null,
    message: null,
    expiryMonth: null,
    expiryYear: null,
    creationDate: null,
    currency: 'USD',
    default: false
};
